const rs_wechat = {
  dev: {
    env: "dev",
    base_url: "https://orx7454qck.execute-api.us-east-1.amazonaws.com/v0",
    sales_info_url: "https://docs.qq.com/sheet/DVG5QZVFmamxGbmVu?tab=BB08J2",
    salesArticleIds: [],
    strategyArticleIds: [],
    newsArticleIds: [],
    welcomeArticle:
      "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000420&idx=1&sn=ba42d416e63dcdaa677f3a37d993bc99&chksm=6878b06e5f0f3978c95ab75cee82cac1b3047717031cd0bf9f0e64732dfafb8d0827789a36f5#rd",
    debug: true,
    sigilUrl: "https://qa-sigil.qashopltk.com",
    legacyHomePage: "https://creator.qashopltk.com",
    accessTokenCookie: "qa_sigil_access_token",
    idTokenCookie: "qa_sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.qashopltk.com/v1",
      clientId: "4seva2GL8OhiWvEz1ilBhSqYhHCwuVDB",
      domain: "qa-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`
    }
  },

  qa: {
    env: "qa",
    base_url: "https://orx7454qck.execute-api.us-east-1.amazonaws.com/v0",
    sales_info_url: "https://docs.qq.com/sheet/DVG5QZVFmamxGbmVu?tab=BB08J2",
    salesArticleIds: [],
    strategyArticleIds: [],
    newsArticleIds: [],
    welcomeArticle:
      "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000420&idx=1&sn=ba42d416e63dcdaa677f3a37d993bc99&chksm=6878b06e5f0f3978c95ab75cee82cac1b3047717031cd0bf9f0e64732dfafb8d0827789a36f5#rd",
    debug: false,
    sigilUrl: "https://qa-sigil.qashopltk.com",
    legacyHomePage: "https://creator.qashopltk.com",
    accessTokenCookie: "qa_sigil_access_token",
    idTokenCookie: "qa_sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.qashopltk.com/v1",
      clientId: "4seva2GL8OhiWvEz1ilBhSqYhHCwuVDB",
      domain: "qa-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`
    }
  },

  prod: {
    env: "prod",
    base_url: "https://7f926mpleb.execute-api.us-east-1.amazonaws.com/v0",
    sales_info_url: "https://docs.qq.com/sheet/DVG5QZVFmamxGbmVu?tab=BB08J2",
    salesArticleIds: [
      "R9lAXiMOFA8wYez87YPRmU03nraxnz80aCjZFPF6iyw",
      "R9lAXiMOFA8wYez87YPRmZ5yLEAXLPqoH3aqyJt7BNA",
      "R9lAXiMOFA8wYez87YPRmVufB5MOnpPnRL31-68UnZo"
    ],
    strategyArticleIds: [
      "R9lAXiMOFA8wYez87YPRmVeRwQqE7WX_8aeJik7fJro",
      "R9lAXiMOFA8wYez87YPRmafTVF2egllCDRpoFyiljho",
      "R9lAXiMOFA8wYez87YPRmf3OrzyqTYe0CJ7IFvnQGfc",
      "R9lAXiMOFA8wYez87YPRmTlCwuo_Qumr073VDVXeInI",
      "R9lAXiMOFA8wYez87YPRmUtPwboP5TzhNUJo6lCMxnA"
    ],
    newsArticleIds: [
      "R9lAXiMOFA8wYez87YPRmVzxzdSjiCvd05jxxZBkGhA",
      "R9lAXiMOFA8wYez87YPRmfDwSCAugoq5QhFwFdFWkYc",
      "R9lAXiMOFA8wYez87YPRmSQAZVU0elb0yY6JFyfjHiE"
    ],
    welcomeArticle:
      "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000420&idx=1&sn=ba42d416e63dcdaa677f3a37d993bc99&chksm=6878b06e5f0f3978c95ab75cee82cac1b3047717031cd0bf9f0e64732dfafb8d0827789a36f5#rd",
    debug: false,
    sigilUrl: "https://auth-creator.shopltk.com",
    legacyHomePage: "https://creator.shopltk.com",
    accessTokenCookie: "sigil_access_token",
    idTokenCookie: "sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.shopltk.com/v1",
      clientId: "JEeuX7A7NePKyttFOSU35VFF8dujFlW7",
      domain: "prod-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`
    }
  }
};

export default rs_wechat;
